// ═══════════════════════════════════════════════
//   CLOWRI QUIZ — one-time popup quiz feature
// ═══════════════════════════════════════════════

const {S, toast, openWin, closeWin, scheduleSave} = window;

// ══════════════════════════════════════════
// CLOWRI QUIZ (logo popup · one-time per account)
// ══════════════════════════════════════════
let cqIdx = 0, cqScore = 0, cqShuffle = [];

function openClowriQuiz() {
    if (S.clowriQuizDone) {
        toast(`You already took the quiz — ${S.clowriQuizScore}/5 ⭐`);
        openWin('w-about');
        if (window.triggerMission) window.triggerMission('read_bio');
        return;
    }
    cqIdx = 0;
    cqScore = 0;
    // Shuffle questions AND shuffle each question's answers while tracking correct
    cqShuffle = QUIZ_DATA.map(q => {
        const opts = q.opts.map((text, i) => ({text, correct: i === q.ans})).sort(() => Math.random() - .5);
        return {...q, shuffledOpts: opts};
    }).sort(() => Math.random() - .5);
    openWin('w-clowri-quiz');
    renderCQ();
}

function renderCQ() {
    const body = document.getElementById('cq-body');
    if (!body) return;
    if (cqIdx >= cqShuffle.length) {
        const stars = '⭐'.repeat(cqScore) + '☆'.repeat(cqShuffle.length - cqScore);
        const label = cqScore === 5 ? 'TRUE KONBINI FAN! 🏆' : cqScore >= 4 ? 'You know Clowri well! ✨' : cqScore >= 3 ? 'Pretty good fan! 🌸' : cqScore >= 2 ? 'Still learning... 📚' : 'Check the About page! 👀';
        body.innerHTML = `<div style="text-align:center;">
      <div style="font-family:'Press Start 2P',monospace;font-size:10px;color:var(--pink);margin-bottom:12px;">RESULTS!</div>
      <div style="font-size:26px;margin-bottom:8px;">${stars}</div>
      <div style="font-family:'Press Start 2P',monospace;font-size:8px;color:var(--dark);margin-bottom:10px;">${cqScore}/${cqShuffle.length} correct</div>
      <div style="font-family:'Nunito',sans-serif;font-size:15px;font-weight:900;color:var(--hot);margin-bottom:18px;">${label}</div>
      <button onclick="saveCQ()" style="background:var(--pink);color:white;border:2px solid var(--dark);border-radius:10px;padding:10px;width:100%;font-family:'Press Start 2P',monospace;font-size:7px;cursor:pointer;box-shadow:0 2px 0 var(--dark);">✦ SAVE RESULT ✦</button>
    </div>`;
        return;
    }
    const q = cqShuffle[cqIdx];
    body.innerHTML = `
    <div style="font-family:'Press Start 2P',monospace;font-size:6px;color:#aaa;margin-bottom:8px;">QUESTION ${cqIdx + 1}/${cqShuffle.length}</div>
    <div style="font-family:'Press Start 2P',monospace;font-size:8px;color:var(--dark);line-height:1.9;margin-bottom:14px;white-space:pre-line;">${q.q}</div>
    <div>${q.shuffledOpts.map((o, i) => `<button onclick="cqAnswer(${i})" style="display:block;width:100%;margin-bottom:6px;padding:10px 12px;background:white;border:2px solid var(--dark);border-radius:8px;font-family:'Nunito',sans-serif;font-size:13px;font-weight:700;cursor:pointer;text-align:left;" onmouseover="this.style.background='var(--soft)'" onmouseout="this.style.background='white'">${String.fromCharCode(65 + i)}. ${o.text}</button>`).join('')}</div>`;
}

function cqAnswer(i) {
    const q = cqShuffle[cqIdx];
    const correct = q.shuffledOpts[i].correct;
    if (correct) cqScore++;
    // Flash feedback
    const btns = document.getElementById('cq-body').querySelectorAll('button');
    btns.forEach((b, bi) => {
        b.disabled = true;
        if (q.shuffledOpts[bi].correct) b.style.background = '#a8e063'; else if (bi === i && !correct) b.style.background = '#ffb3b3';
    });
    setTimeout(() => {
        cqIdx++;
        renderCQ();
    }, 700);
}

function saveCQ() {
    S.clowriQuizDone = true;
    S.clowriQuizScore = cqScore;
    scheduleSave();
    toast(`Quiz saved! You scored ${cqScore}/${cqShuffle.length} ⭐`);
    closeWin('w-clowri-quiz');
}


const QUIZ_DATA = [
    {q: "What is Clowri's nationality?", opts: ["French", "Spanish", "Italian", "German"], ans: 1},
    {
        q: "Which convention is Clowri\nattending in 2026?",
        opts: ["Comiket", "Japan Expo", "Dokomi", "MCM London"],
        ans: 2
    },
    {
        q: "What does Clowri love to draw?",
        opts: ["Robots & sci-fi", "Cute stuff & pretty women", "Landscapes", "Architecture"],
        ans: 1
    },
    {
        q: "What is the theme of\nthis website?",
        opts: ["A bakery", "A bookshop", "A konbini", "A manga café"],
        ans: 2
    },
    {
        q: "What subnick do you\nstart with?",
        opts: ["• Konbini Staff", "• Chronically online ✦", "• Dokomi VIP", "• Daily Visitor"],
        ans: 1
    },
];
let quizOverlay = null;

function resetQuiz() {
    cqIdx = 0;
    cqScore = 0;
    cqShuffle = [];
}

window.openClowriQuiz = openClowriQuiz;
window.renderCQ = renderCQ;
window.cqAnswer = cqAnswer;
window.saveCQ = saveCQ;
window.resetQuiz = resetQuiz;
